import { createSlice } from '@reduxjs/toolkit';

const showroomDealerSlice = createSlice({
  name: 'showroomDealer',
  initialState: {
    loading: false,
    data: [],
    error: null
  },
  reducers: {
    getShowroomDealer: (state) => {
      state.loading = true;
    },
    successShowroomDealer: (state, action) => {
      state.loading = false;
      state.data = action.payload;
    },
    addShowroomDealer: (state) => {
      state.loading = true;
    },
    updateShowroomDealer: (state) => {
      state.loading = true;
    },
    removeShowroomDealer: (state) => {
      state.loading = true;
    }
  }
});

export const { getShowroomDealer, successShowroomDealer, addShowroomDealer, updateShowroomDealer, removeShowroomDealer } =
  showroomDealerSlice.actions;

export default showroomDealerSlice.reducer;
